import { render } from "./brandNew.vue?vue&type=template&id=72c56b82&scoped=true"
import script from "./brandNew.vue?vue&type=script&lang=js"
export * from "./brandNew.vue?vue&type=script&lang=js"

import "./brandNew.vue?vue&type=style&index=0&id=72c56b82&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c56b82"]])

export default __exports__